import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import type { PlayerStatsResponse } from "@bw/shared/types/generated";
import { MISSING, winRateLabel } from "./competeDisplay";

function FormatRow({
  label,
  played,
  winRate,
}: {
  label: string;
  played: number;
  winRate: number;
}) {
  return (
    <TableRow>
      <TableCell component="th" scope="row" sx={{ pl: 0 }}>
        {label}
      </TableCell>
      <TableCell align="right">{played}</TableCell>
      <TableCell align="right" sx={{ pr: 0 }}>
        {winRateLabel(winRate, played)}
      </TableCell>
    </TableRow>
  );
}

function Stat({ label, value }: { label: string; value: string | number }) {
  return (
    <Box sx={{ textAlign: "center" }}>
      <Typography component="p" sx={{ fontSize: "1.375rem", fontWeight: 800, lineHeight: 1.2 }}>
        {value}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
}

export function StatsPanel({ stats }: { stats: PlayerStatsResponse }) {
  return (
    <Stack component="section" aria-label="Match statistics" data-testid="stats-panel" spacing={1.5}>
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: 1 }}>
        <Stat label="Matches" value={stats.games_played} />
        <Stat label="Win rate" value={winRateLabel(stats.win_rate, stats.games_played)} />
        <Stat label="Streak" value={MISSING} />
      </Box>
      <Table size="small" aria-label="Statistics by format" sx={{ "& td, & th": { borderColor: "divider" } }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ pl: 0, color: "text.secondary" }}>Format</TableCell>
            <TableCell align="right" sx={{ color: "text.secondary" }}>Games</TableCell>
            <TableCell align="right" sx={{ pr: 0, color: "text.secondary" }}>Win rate</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <FormatRow label="Singles" played={stats.singles_played} winRate={stats.singles_win_rate} />
          <FormatRow label="Doubles" played={stats.doubles_played} winRate={stats.doubles_win_rate} />
          <FormatRow label="Mixed" played={stats.mixed_played ?? 0} winRate={stats.mixed_win_rate ?? 0} />
        </TableBody>
      </Table>
    </Stack>
  );
}
